export const NATIVE_TOKEN_SYMBOLS = {
  uusd: 'UST'
};

export const NATIVE_TOKEN_DECIMALS = 6;
